import { render } from "./ImageViewerToolbar.vue?vue&type=template&id=5263efba&scoped=true&ts=true"
import script from "./ImageViewerToolbar.vue?vue&type=script&lang=ts"
export * from "./ImageViewerToolbar.vue?vue&type=script&lang=ts"

import "./ImageViewerToolbar.vue?vue&type=style&index=0&id=5263efba&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5263efba"]])

export default __exports__